import { default as _403evirc7Gg70Meta } from "/home/nodejs/kare-backoffice-v2/source/pages/403.vue?macro=true";
import { default as ai_45product_45data_45generation0nnNl9RYmlMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/assistant/ai-product-data-generation.vue?macro=true";
import { default as ai_45product_45data_45purgelF6mDDM3MiMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/assistant/ai-product-data-purge.vue?macro=true";
import { default as _91id_93CmkIKTmkLBMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/assistant/ai-product-data-review/[id].vue?macro=true";
import { default as indexNPWxbaQTVGMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/assistant/ai-product-data-review/index.vue?macro=true";
import { default as ai_45product_45data_45reviewcIHRxlH4y1Meta } from "/home/nodejs/kare-backoffice-v2/source/pages/assistant/ai-product-data-review.vue?macro=true";
import { default as _91id_93Y6AosqkFLMMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/assistant/ai-product-data/[id].vue?macro=true";
import { default as indexud4rlCwINIMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/assistant/ai-product-data/index.vue?macro=true";
import { default as assistantAttributesSelect_46inputGmZqUSv5YNMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/assistant/inputs/assistantAttributesSelect.input.ts?macro=true";
import { default as _91id_93XoEFUwwaR5Meta } from "/home/nodejs/kare-backoffice-v2/source/pages/attribute-groups/[id].vue?macro=true";
import { default as indexq9RlTmoDyfMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/attribute-groups/index.vue?macro=true";
import { default as newHu3FnInoaJMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/attribute-groups/new.vue?macro=true";
import { default as attribute_45groupsuFAbBl00P4Meta } from "/home/nodejs/kare-backoffice-v2/source/pages/attribute-groups.vue?macro=true";
import { default as _91lang_93lgliUZ11irMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/attributes/[id]/attribute-values/[lang].vue?macro=true";
import { default as indexQUVUOzUyQdMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/attributes/[id]/index.vue?macro=true";
import { default as indexez85J2dTSyMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/attributes/index.vue?macro=true";
import { default as _91id_93OBjqRqkMaTMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/authors/[id].vue?macro=true";
import { default as indexRX846GxOLvMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/authors/index.vue?macro=true";
import { default as newwp2cfRkdThMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/authors/new.vue?macro=true";
import { default as indexBjsL2l6uQEMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/baselinker/index.vue?macro=true";
import { default as basketsim8cSoMOMfnjMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/basketsim.vue?macro=true";
import { default as adspend_45togglecyoHaGWxkWMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/bi-center/filters/adspend-toggle.ts?macro=true";
import { default as fast_45delivery_45toggleb0aLfkV6qyMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/bi-center/filters/fast-delivery-toggle.ts?macro=true";
import { default as metric_45dateu2hmLPm3LiMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/bi-center/filters/metric-date.ts?macro=true";
import { default as indexlpmgH5NivxMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/bi-center/index.vue?macro=true";
import { default as manufacturer_45marginshblCSNIzfRMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/bi-center/manufacturer-margins.vue?macro=true";
import { default as manufacturersXaJT6GsqujMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/bi-center/manufacturers.vue?macro=true";
import { default as margin_45checkszfxsbjAvdqMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/bi-center/margin-checks.vue?macro=true";
import { default as metrics_45valuesC8rcHrATwGMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/bi-center/metrics-values.vue?macro=true";
import { default as performance_45stocksA2Y1NTImVPMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/bi-center/performance-stocks.vue?macro=true";
import { default as poasRD80Lra1XBMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/bi-center/poas.vue?macro=true";
import { default as product_45metricskh09hI2e9kMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/bi-center/product-metrics.vue?macro=true";
import { default as _91productId_93_45_91channelId_93ZcC6zIruWCMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/bi-center/product-poas/[productId]-[channelId].vue?macro=true";
import { default as indexXpbsZddeE2Meta } from "/home/nodejs/kare-backoffice-v2/source/pages/bi-center/product-poas/index.vue?macro=true";
import { default as statsbnSOSq3VlkMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/bi-center/stats.vue?macro=true";
import { default as bi_45centereeXeomSTGiMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/bi-center.vue?macro=true";
import { default as indexKKvwRVeUrSMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/cache/index.vue?macro=true";
import { default as _91id_93Tb6jdi2hXlMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/campaigns/[id].vue?macro=true";
import { default as indexF718gUBO1iMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/campaigns/index.vue?macro=true";
import { default as newnGFFOpjjnjMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/campaigns/new.vue?macro=true";
import { default as _91id_93iIBsMgl5YxMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/carriers/[id].vue?macro=true";
import { default as index31aFoU96ZyMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/carriers/index.vue?macro=true";
import { default as new0s7aPqhrJlMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/carriers/new.vue?macro=true";
import { default as carrierszQjHGcMwbHMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/carriers.vue?macro=true";
import { default as _91id_93lhZB2IHupdMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/categories/[id].vue?macro=true";
import { default as clone_45tree6PqGArvFEsMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/categories/clone-tree.vue?macro=true";
import { default as active_46selectE580ioXvbMMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/categories/filters/active.select.ts?macro=true";
import { default as emptyDescription_46toggle3SVwLHslRmMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/categories/filters/emptyDescription.toggle.ts?macro=true";
import { default as emptyHeaderImage_46selectVWs4XyhgVxMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/categories/filters/emptyHeaderImage.select.ts?macro=true";
import { default as emptyName_46select57e5G2zIcxMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/categories/filters/emptyName.select.ts?macro=true";
import { default as emptyProductFilters_46selectbdPISIp12nMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/categories/filters/emptyProductFilters.select.ts?macro=true";
import { default as emptySateliteDesc_46selectA3UHRUx1X1Meta } from "/home/nodejs/kare-backoffice-v2/source/pages/categories/filters/emptySateliteDesc.select.ts?macro=true";
import { default as emptySeoDesc_46togglePU11Hq4r3FMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/categories/filters/emptySeoDesc.toggle.ts?macro=true";
import { default as emptySeoTitle_46togglegveUPR2RmhMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/categories/filters/emptySeoTitle.toggle.ts?macro=true";
import { default as excludeFromAutoComplete_46select9zFX1tdMZtMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/categories/filters/excludeFromAutoComplete.select.ts?macro=true";
import { default as query_46selectDDkIAq1ynFMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/categories/filters/query.select.ts?macro=true";
import { default as sort_46selectqzZc6zZjRvMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/categories/filters/sort.select.ts?macro=true";
import { default as status_46selectEKh93Z4zpZMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/categories/filters/status.select.ts?macro=true";
import { default as virtual_46selectWtJANMUPhgMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/categories/filters/virtual.select.ts?macro=true";
import { default as visibility_46selectqbJa2EnWhUMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/categories/filters/visibility.select.ts?macro=true";
import { default as indexFxaitTICR1Meta } from "/home/nodejs/kare-backoffice-v2/source/pages/categories/index.vue?macro=true";
import { default as categoryAttributes_46inputsf4G0woiE6Meta } from "/home/nodejs/kare-backoffice-v2/source/pages/categories/inputs/categoryAttributes.input.ts?macro=true";
import { default as categoryTree_46inputjl4vjKheImMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/categories/inputs/categoryTree.input.ts?macro=true";
import { default as mappings59PfxZ5ILhMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/categories/mappings.vue?macro=true";
import { default as newVd4xhkFekdMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/categories/new.vue?macro=true";
import { default as _91id_93nStMeTUHogMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/categories/product-sorting/[id].vue?macro=true";
import { default as treesoUTHF1KXuMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/categories/tree.vue?macro=true";
import { default as indexYHXzpSdIkrMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/categories/virtual-categories/index.vue?macro=true";
import { default as categoriesUA8VD2kCmaMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/categories.vue?macro=true";
import { default as _91id_93PGSRFJvGKRMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/channels/[id].vue?macro=true";
import { default as available_46select0b8kH82lt5Meta } from "/home/nodejs/kare-backoffice-v2/source/pages/channels/filters/available.select.ts?macro=true";
import { default as hasMapping_46selectazJwZjMwxKMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/channels/filters/hasMapping.select.ts?macro=true";
import { default as indexg9mncrei4kMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/channels/index.vue?macro=true";
import { default as fisEnabled_46toggleukLayZm9JAMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/channels/inputs/fisEnabled.toggle.ts?macro=true";
import { default as overwrite_46toggleBSjo0gs0zdMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/channels/inputs/overwrite.toggle.ts?macro=true";
import { default as productsStatus_46inputJkFNuAkDH0Meta } from "/home/nodejs/kare-backoffice-v2/source/pages/channels/inputs/productsStatus.input.ts?macro=true";
import { default as sitemaps_46inputsqNuyjYwVOqMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/channels/inputs/sitemaps.inputs.ts?macro=true";
import { default as type_46inputLjum0NEAtjMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/channels/inputs/type.input.ts?macro=true";
import { default as migrationfSOvd93JmDMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/channels/migration.vue?macro=true";
import { default as newqMm73ng2RhMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/channels/new.vue?macro=true";
import { default as remote_45categoriesaV59dv6L4qMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/channels/remote-categories.vue?macro=true";
import { default as channels4cZpwXLboqMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/channels.vue?macro=true";
import { default as _91id_93SFoUuxJIlgMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/collections/[id].vue?macro=true";
import { default as indexPBz09OaSyQMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/collections/index.vue?macro=true";
import { default as new0zICfjlhCNMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/collections/new.vue?macro=true";
import { default as _91id_93G1oQu853mMMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/countries/[id].vue?macro=true";
import { default as indexjlB02JdabcMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/countries/index.vue?macro=true";
import { default as newmYaxob0ztkMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/countries/new.vue?macro=true";
import { default as _91id_93QkEQCFcXnbMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/currencies/[id].vue?macro=true";
import { default as indexuLcMlNM5clMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/currencies/index.vue?macro=true";
import { default as newgi2gsBMQ8AMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/currencies/new.vue?macro=true";
import { default as currenciesnhAZw5m04wMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/currencies.vue?macro=true";
import { default as _91id_93JtP4p1PvgcMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/customer-groups/[id].vue?macro=true";
import { default as indexzpVdylgdB7Meta } from "/home/nodejs/kare-backoffice-v2/source/pages/customer-groups/index.vue?macro=true";
import { default as newKr9lxDcwWvMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/customer-groups/new.vue?macro=true";
import { default as customer_45groupslhugwLOFepMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/customer-groups.vue?macro=true";
import { default as mailWuNlPszeGjMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/customers/[customer]/mail.vue?macro=true";
import { default as _91message_93RUfGkNzggkMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/customers/[customer]/messages/[message].vue?macro=true";
import { default as _91id_93MfxdAk7oA2Meta } from "/home/nodejs/kare-backoffice-v2/source/pages/customers/[id].vue?macro=true";
import { default as indexKveDgQyuo5Meta } from "/home/nodejs/kare-backoffice-v2/source/pages/customers/index.vue?macro=true";
import { default as isMarketingAccepted_46toggle4oye6o5MATMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/customers/inputs/isMarketingAccepted.toggle.ts?macro=true";
import { default as isMarketingSubscribed_46toggle7rNHLKsRebMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/customers/inputs/isMarketingSubscribed.toggle.ts?macro=true";
import { default as isTermsAccepted_46toggle7MKmVQvyYVMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/customers/inputs/isTermsAccepted.toggle.ts?macro=true";
import { default as newVJoBrESZTqMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/customers/new.vue?macro=true";
import { default as _91id_93jtywLAuhzaMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/delivery-methods/[id].vue?macro=true";
import { default as indexOjkqVSO7QyMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/delivery-methods/index.vue?macro=true";
import { default as newYXjCDLyZbdMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/delivery-methods/new.vue?macro=true";
import { default as _91id_93YExAoKYy5yMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/delivery-methods/services/[id].vue?macro=true";
import { default as index8pnrZyyCElMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/delivery-methods/services/index.vue?macro=true";
import { default as newhrIJLHwEViMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/delivery-methods/services/new.vue?macro=true";
import { default as indextRTvO4uRj8Meta } from "/home/nodejs/kare-backoffice-v2/source/pages/exports/[id]/index.vue?macro=true";
import { default as statsHoJGCHeSr5Meta } from "/home/nodejs/kare-backoffice-v2/source/pages/exports/[id]/stats.vue?macro=true";
import { default as index3iSa6zOJSTMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/exports/debug/index.vue?macro=true";
import { default as indexdpk8cdhmIOMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/exports/index.vue?macro=true";
import { default as modeluOAaR1Ip54Meta } from "/home/nodejs/kare-backoffice-v2/source/pages/exports/model.ts?macro=true";
import { default as indexIp86ZVnJXKMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/exports/new/[id]/index.vue?macro=true";
import { default as indexMKPe9EX1pPMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/exports/new/index.vue?macro=true";
import { default as exportsHyYOr79BNEMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/exports.vue?macro=true";
import { default as _91id_93BfGFKrotFSMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/flags/[id].vue?macro=true";
import { default as indexXDA2vDMah2Meta } from "/home/nodejs/kare-backoffice-v2/source/pages/flags/index.vue?macro=true";
import { default as isHidden_46inputxrQqB1OLq0Meta } from "/home/nodejs/kare-backoffice-v2/source/pages/flags/inputs/isHidden.input.ts?macro=true";
import { default as new9qIMFMvFoeMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/flags/new.vue?macro=true";
import { default as flagsqZBMFpC7DHMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/flags.vue?macro=true";
import { default as indexzmtpKoT5M2Meta } from "/home/nodejs/kare-backoffice-v2/source/pages/image-studio/index.vue?macro=true";
import { default as image_45studioa5ZPRQRtFjMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/image-studio.vue?macro=true";
import { default as _91id_93qWz2GIcNNKMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/imports/[id].vue?macro=true";
import { default as import_45type_46selectJIVHzr7LB8Meta } from "/home/nodejs/kare-backoffice-v2/source/pages/imports/filters/import-type.select.ts?macro=true";
import { default as parent_45import_46selectDxB868HIRoMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/imports/filters/parent-import.select.ts?macro=true";
import { default as status_46select9erQ9SQNkvMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/imports/filters/status.select.ts?macro=true";
import { default as _91id_934hfLmv5QwXMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/imports/import-rows/[id].vue?macro=true";
import { default as status_46selectbXrsmLHLQsMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/imports/import-rows/filters/status.select.ts?macro=true";
import { default as indexsqwdhc5yu9Meta } from "/home/nodejs/kare-backoffice-v2/source/pages/imports/index.vue?macro=true";
import { default as new_45oldxjbOywWWjRMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/imports/new-old.vue?macro=true";
import { default as indexQZVeq1UcfvMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/imports/new/[id]/index.vue?macro=true";
import { default as index0Sy6ieITAUMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/imports/new/index.vue?macro=true";
import { default as index8ifEZIgENaMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/index.vue?macro=true";
import { default as _91id_93tCNWY4bYBFMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/inspiration-images/[id].vue?macro=true";
import { default as indexoHEk6SBvZcMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/inspiration-images/index.vue?macro=true";
import { default as newP96K57wEVLMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/inspiration-images/new.vue?macro=true";
import { default as _91id_93cGe44iNMrIMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/inspirations/[id].vue?macro=true";
import { default as indexuUi9OX4eSvMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/inspirations/index.vue?macro=true";
import { default as new7jNjH5lStNMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/inspirations/new.vue?macro=true";
import { default as inspirationsI3NEfSTeYpMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/inspirations.vue?macro=true";
import { default as indexrvD6q7iMa7Meta } from "/home/nodejs/kare-backoffice-v2/source/pages/integrations/hq-stock/index.vue?macro=true";
import { default as indexih5IOgjcFeMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/integrations/index.vue?macro=true";
import { default as indexMMdZ54vmnZMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/integrations/kare-tracking/index.vue?macro=true";
import { default as indexu59lH9Pye2Meta } from "/home/nodejs/kare-backoffice-v2/source/pages/internal/product-index/index.vue?macro=true";
import { default as status_46selectowXNkwkH1fMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/jobs/filters/status.select.ts?macro=true";
import { default as types_46selectMNgfH2AtdyMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/jobs/filters/types.select.ts?macro=true";
import { default as indexzaHnZtXSp1Meta } from "/home/nodejs/kare-backoffice-v2/source/pages/jobs/index.vue?macro=true";
import { default as knowledge_45baseo193IjWSVKMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/knowledge-base.vue?macro=true";
import { default as _91id_93Z0k4Bak7SIMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/languages/[id].vue?macro=true";
import { default as indexuPJ9GiwRrbMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/languages/index.vue?macro=true";
import { default as newQXr5VsCTECMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/languages/new.vue?macro=true";
import { default as _91id_93hFxP8m38D5Meta } from "/home/nodejs/kare-backoffice-v2/source/pages/links/[id].vue?macro=true";
import { default as indexTKaI8tEDlDMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/links/index.vue?macro=true";
import { default as new4ppBxYWsYxMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/links/new.vue?macro=true";
import { default as _91id_93ldaGvQXrfhMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/listing-dividers/[id].vue?macro=true";
import { default as indexPVurnkjiiOMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/listing-dividers/index.vue?macro=true";
import { default as new2UrNwt27k3Meta } from "/home/nodejs/kare-backoffice-v2/source/pages/listing-dividers/new.vue?macro=true";
import { default as loginJbQ990ojpbMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/login.vue?macro=true";
import { default as logouthfA9cnGkAgMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/logout.vue?macro=true";
import { default as _91id_936vCcY7F3vlMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/mailchimp-list-configs/[id].vue?macro=true";
import { default as indexI3X34ZbKMgMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/mailchimp-list-configs/index.vue?macro=true";
import { default as newcci6VXw7PvMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/mailchimp-list-configs/new.vue?macro=true";
import { default as _91id_93t4BnGJTCYOMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/manufacturer-deliveries/[id].vue?macro=true";
import { default as indexIONIEDpiGQMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/manufacturer-deliveries/bulk-create/index.vue?macro=true";
import { default as dayOfWeekSelect_46inputflQeb6Y4GqMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/manufacturer-deliveries/bulk-create/inputs/dayOfWeekSelect.input.ts?macro=true";
import { default as periodSelect_46inputUp31zfa8IdMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/manufacturer-deliveries/bulk-create/inputs/periodSelect.input.ts?macro=true";
import { default as indexeQJuJwmJb2Meta } from "/home/nodejs/kare-backoffice-v2/source/pages/manufacturer-deliveries/bulk-delete/index.vue?macro=true";
import { default as indexCd7mrFLUimMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/manufacturer-deliveries/index.vue?macro=true";
import { default as newLUppRCdfmqMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/manufacturer-deliveries/new.vue?macro=true";
import { default as manufacturer_45deliverieshMNtv1Ddj1Meta } from "/home/nodejs/kare-backoffice-v2/source/pages/manufacturer-deliveries.vue?macro=true";
import { default as _91id_93LKrb4TXPKkMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/manufacturers/[id].vue?macro=true";
import { default as indexCcJg9I9xVgMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/manufacturers/index.vue?macro=true";
import { default as newOj1wtixdl5Meta } from "/home/nodejs/kare-backoffice-v2/source/pages/manufacturers/new.vue?macro=true";
import { default as manufacturerso0APnhraqeMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/manufacturers.vue?macro=true";
import { default as indexrzrUnnsN58Meta } from "/home/nodejs/kare-backoffice-v2/source/pages/meble/index.vue?macro=true";
import { default as _91id_93djNaWe34G0Meta } from "/home/nodejs/kare-backoffice-v2/source/pages/menu/[id].vue?macro=true";
import { default as indexOIqnOvuC2iMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/menu/index.vue?macro=true";
import { default as layout_46inputlLDcfwztxhMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/menu/inputs/layout.input.ts?macro=true";
import { default as type_46inputNk2muLiQ6dMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/menu/inputs/type.input.ts?macro=true";
import { default as newMCO6hBhqQeMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/menu/new.vue?macro=true";
import { default as utils34mymte0BtMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/menu/utils.ts?macro=true";
import { default as indexFe0MOIvSmPMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/module-groups/[id]/index.vue?macro=true";
import { default as __91type_93md4GwEhtADMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/module-groups/[id]/modules/_[type].vue?macro=true";
import { default as _91moduleId_93koLjI0WSRzMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/module-groups/[id]/modules/[moduleId].vue?macro=true";
import { default as _91type_93imY2ZBK9BOMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/module-groups/[id]/modules/edit/[moduleId]/[type].vue?macro=true";
import { default as _91type_93fMcwFxirPeMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/module-groups/[id]/modules/new/[type].vue?macro=true";
import { default as indexTcN7ZZoJ55Meta } from "/home/nodejs/kare-backoffice-v2/source/pages/module-groups/[id]/modules/new/index.vue?macro=true";
import { default as indexZPMDMwT6xpMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/module-groups/index.vue?macro=true";
import { default as newuv2XQcYYDjMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/module-groups/new.vue?macro=true";
import { default as module_45groupseaZzp3hfnwMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/module-groups.vue?macro=true";
import { default as _91id_93snBQDLsukrMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/order-statuses/[id].vue?macro=true";
import { default as default_45status_46toggleqJBoO7cjmJMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/order-statuses/filters/default-status.toggle.ts?macro=true";
import { default as indexl1tpR4wKnYMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/order-statuses/index.vue?macro=true";
import { default as newD7V3EwvCtaMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/order-statuses/new.vue?macro=true";
import { default as indexlRLcQ7Mo6yMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/orders/[id]/index.vue?macro=true";
import { default as _91message_93mWouYHI8tmMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/orders/[id]/messages/[message].vue?macro=true";
import { default as indexY2PtlBzE2aMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/orders/index.vue?macro=true";
import { default as newjqfZOtzaMvMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/orders/new.vue?macro=true";
import { default as index7wbXhKsK5DMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/orders/pending-shipments/index.vue?macro=true";
import { default as indexacGpLrWaAKMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/orders/promised-deliveries/index.vue?macro=true";
import { default as indextFsQTsfuQUMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/orders/shd-mappings/index.vue?macro=true";
import { default as newL7NYZvyQYhMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/orders/shd-mappings/new.vue?macro=true";
import { default as ordersyEkRSkcLjIMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/orders.vue?macro=true";
import { default as _91id_934XO0HRrLc1Meta } from "/home/nodejs/kare-backoffice-v2/source/pages/pages/[id].vue?macro=true";
import { default as indexUOQ4YllrTBMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/pages/index.vue?macro=true";
import { default as newcHongjyRkaMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/pages/new.vue?macro=true";
import { default as _91id_93c1tpNem7yNMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/partners/[id].vue?macro=true";
import { default as indexD07gyR4VlGMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/partners/index.vue?macro=true";
import { default as newvnBq9ibXD3Meta } from "/home/nodejs/kare-backoffice-v2/source/pages/partners/new.vue?macro=true";
import { default as _91id_93pKoyJTUkfCMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/payment-methods/[id].vue?macro=true";
import { default as indexBs6ef7LpyoMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/payment-methods/index.vue?macro=true";
import { default as newpJWbXWdYhQMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/payment-methods/new.vue?macro=true";
import { default as adyenrfoF434eBUMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/payment-methods/schemas/adyen.ts?macro=true";
import { default as boricaakvkLN5NXUMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/payment-methods/schemas/borica.ts?macro=true";
import { default as fibankwg5JWoGAgRMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/payment-methods/schemas/fibank.ts?macro=true";
import { default as imojeBzoLfI5jYQMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/payment-methods/schemas/imoje.ts?macro=true";
import { default as indexsggzcABy44Meta } from "/home/nodejs/kare-backoffice-v2/source/pages/payment-methods/schemas/index.ts?macro=true";
import { default as intensaw2mlZTPhzKMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/payment-methods/schemas/intensa.ts?macro=true";
import { default as iyzicoSJ8ODcPMimMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/payment-methods/schemas/iyzico.ts?macro=true";
import { default as khrQUYQxxvtmMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/payment-methods/schemas/kh.ts?macro=true";
import { default as klarnaqTDoF9MJ4MMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/payment-methods/schemas/klarna.ts?macro=true";
import { default as kustomT5w7Vb9tCXMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/payment-methods/schemas/kustom.ts?macro=true";
import { default as neopayrogSSPnB3QMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/payment-methods/schemas/neopay.ts?macro=true";
import { default as paymentezybNcYVwsfnMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/payment-methods/schemas/paymentez.ts?macro=true";
import { default as paynld8izTf0D39Meta } from "/home/nodejs/kare-backoffice-v2/source/pages/payment-methods/schemas/paynl.ts?macro=true";
import { default as paypomwUfGP8mEqMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/payment-methods/schemas/paypo.ts?macro=true";
import { default as payu90lReYAGsHMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/payment-methods/schemas/payu.ts?macro=true";
import { default as payuv4C2ovwcpfhhMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/payment-methods/schemas/payuv4.ts?macro=true";
import { default as powertranz8NeWZtHioVMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/payment-methods/schemas/powertranz.ts?macro=true";
import { default as wirecardEnksQVzSloMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/payment-methods/schemas/wirecard.ts?macro=true";
import { default as wspayyld6tYgczyMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/payment-methods/schemas/wspay.ts?macro=true";
import { default as webhooksZfiSDcOMl2Meta } from "/home/nodejs/kare-backoffice-v2/source/pages/payment-methods/webhooks.vue?macro=true";
import { default as printerxfVQHaXeHyMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/printer.vue?macro=true";
import { default as _91id_9389DtZFQchIMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/product-families/[id].vue?macro=true";
import { default as indexjVEr9Xcu95Meta } from "/home/nodejs/kare-backoffice-v2/source/pages/product-families/index.vue?macro=true";
import { default as newGnwQkgqSISMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/product-families/new.vue?macro=true";
import { default as product_45familieszPSASkY2GWMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/product-families.vue?macro=true";
import { default as indexslYhB9APl0Meta } from "/home/nodejs/kare-backoffice-v2/source/pages/product-filters/[id]/index.vue?macro=true";
import { default as sortNPjWUdVgsAMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/product-filters/[id]/sort.vue?macro=true";
import { default as statskg0w5CJkkgMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/product-filters/[id]/stats.vue?macro=true";
import { default as indexsic8BmoTR7Meta } from "/home/nodejs/kare-backoffice-v2/source/pages/product-filters/index.vue?macro=true";
import { default as new0x3vlfJOxwMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/product-filters/new.vue?macro=true";
import { default as index9ZbkduC43NMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/product-filters/product-filter-results/index.vue?macro=true";
import { default as product_45filters5HUX3W1bvYMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/product-filters.vue?macro=true";
import { default as indexXJYIvLUGtTMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/product-stock-logs/index.vue?macro=true";
import { default as indexek3gqR7l4SMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/product-stocks/debug/index.vue?macro=true";
import { default as indexMd1v5mynatMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/product-stocks/index.vue?macro=true";
import { default as product_45stocks1Zi5M8JzN3Meta } from "/home/nodejs/kare-backoffice-v2/source/pages/product-stocks.vue?macro=true";
import { default as _91id_93NFx0YolwTwMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/products/[id].vue?macro=true";
import { default as _91id_93DyA7XLg9QDMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/products/configurator-groups/[id].vue?macro=true";
import { default as indexuOxHXYtoeaMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/products/configurator-groups/index.vue?macro=true";
import { default as newzrBl0NWUrvMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/products/configurator-groups/new.vue?macro=true";
import { default as _91id_93DgpB9yZP8zMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/products/coupons-info-box/[id].vue?macro=true";
import { default as indexBVYddO4KMxMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/products/coupons-info-box/index.vue?macro=true";
import { default as newbcpza97yA2Meta } from "/home/nodejs/kare-backoffice-v2/source/pages/products/coupons-info-box/new.vue?macro=true";
import { default as _91id_93Nob77pyZMkMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/products/coupons/[id].vue?macro=true";
import { default as index3nh2f25q1qMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/products/coupons/index.vue?macro=true";
import { default as checkPrefix_46toggletF4GgNZwaSMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/products/coupons/inputs/checkPrefix.toggle.ts?macro=true";
import { default as discountedApplicable_46togglekf1FGTf3bVMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/products/coupons/inputs/discountedApplicable.toggle.ts?macro=true";
import { default as highestDiscount_46toggleB8tymkhgjKMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/products/coupons/inputs/highestDiscount.toggle.ts?macro=true";
import { default as isFreeDelivery_46togglesfo5V1XNjMMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/products/coupons/inputs/isFreeDelivery.toggle.ts?macro=true";
import { default as loggedInUserOnly_46togglepqTebYenSjMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/products/coupons/inputs/loggedInUserOnly.toggle.ts?macro=true";
import { default as showCouponInfo_46toggle2xL4hlK6xZMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/products/coupons/inputs/showCouponInfo.toggle.ts?macro=true";
import { default as showOnProductListing_46togglemZIznzWT5pMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/products/coupons/inputs/showOnProductListing.toggle.ts?macro=true";
import { default as newlaP1ZAftnnMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/products/coupons/new.vue?macro=true";
import { default as index28cwHYLs1kMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/products/customerGroupPrices/index.vue?macro=true";
import { default as indexfW064sbYGCMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/products/debug/index.vue?macro=true";
import { default as indexhaHaia0jyxMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/products/hiddenProducts/index.vue?macro=true";
import { default as indexf3r53P0gafMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/products/index.vue?macro=true";
import { default as _91id_93xlS4YQXZZMMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/products/info-box/[id].vue?macro=true";
import { default as indexlzCxnT73cWMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/products/info-box/index.vue?macro=true";
import { default as newSXcMZQlCJOMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/products/info-box/new.vue?macro=true";
import { default as index9gpPmZuue6Meta } from "/home/nodejs/kare-backoffice-v2/source/pages/products/lowestPrices/index.vue?macro=true";
import { default as _91id_93HeXSbrxgvxMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/products/materialSamples/[id].vue?macro=true";
import { default as indextVvj0V53GAMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/products/materialSamples/index.vue?macro=true";
import { default as newAiXpaNMVJRMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/products/materialSamples/new.vue?macro=true";
import { default as materialSamplesNpKFNLEXEMMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/products/materialSamples.vue?macro=true";
import { default as index8aQdfEBia5Meta } from "/home/nodejs/kare-backoffice-v2/source/pages/products/missingProducts/index.vue?macro=true";
import { default as newQffgHJbJlIMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/products/new.vue?macro=true";
import { default as _91id_93t4FzoWogH8Meta } from "/home/nodejs/kare-backoffice-v2/source/pages/products/price-syncs/[id].vue?macro=true";
import { default as indexldEofoFAEbMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/products/price-syncs/index.vue?macro=true";
import { default as newkKXajn7t7iMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/products/price-syncs/new.vue?macro=true";
import { default as _91id_9306IydaWtIjMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/products/promotions/[id].vue?macro=true";
import { default as _91id_93UPA8ululvIMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/products/promotions/bars/[id].vue?macro=true";
import { default as indexKreXSar0KBMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/products/promotions/bars/index.vue?macro=true";
import { default as newMZXvvZb8JaMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/products/promotions/bars/new.vue?macro=true";
import { default as indexEk17JlKZuVMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/products/promotions/exact-promotions/index.vue?macro=true";
import { default as indexKEq3DgjqHqMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/products/promotions/index.vue?macro=true";
import { default as _91id_93FK6Uv9FFtDMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/products/promotions/multibuy-promotions/[id].vue?macro=true";
import { default as indexsdp8dJKF7SMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/products/promotions/multibuy-promotions/index.vue?macro=true";
import { default as newGZuCh268UYMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/products/promotions/multibuy-promotions/new.vue?macro=true";
import { default as new3S6bmJHk7TMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/products/promotions/new.vue?macro=true";
import { default as promotionsCaGebW3onPMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/products/promotions.vue?macro=true";
import { default as _91id_93YFM4kJ1fdVMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/products/reviews/[id].vue?macro=true";
import { default as index1cWqYx3K2rMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/products/reviews/index.vue?macro=true";
import { default as rating_46inputTR5llfiQkgMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/products/reviews/inputs/rating.input.ts?macro=true";
import { default as newKXkugyZ17KMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/products/reviews/new.vue?macro=true";
import { default as selectionLPrPRBcG0VMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/products/selection.vue?macro=true";
import { default as productsZ2XmSPOuSpMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/products.vue?macro=true";
import { default as indexTm9rXDbu1JMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/profile/index.vue?macro=true";
import { default as indexMGDQAFyzAjMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/purchase-webhooks/index.vue?macro=true";
import { default as _91id_93WMxhVmJX93Meta } from "/home/nodejs/kare-backoffice-v2/source/pages/redirects/[id].vue?macro=true";
import { default as index4OE72COPhDMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/redirects/index.vue?macro=true";
import { default as newQ3rmxlhHVYMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/redirects/new.vue?macro=true";
import { default as indexjH8n6LXhIKMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/reports/index.vue?macro=true";
import { default as indexTLADeiIT74Meta } from "/home/nodejs/kare-backoffice-v2/source/pages/reports/new/[id]/index.vue?macro=true";
import { default as indexOhgjXpFL02Meta } from "/home/nodejs/kare-backoffice-v2/source/pages/reports/new/index.vue?macro=true";
import { default as _91id_93DBkblI3rwKMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/reports/product-metrics/[id].vue?macro=true";
import { default as reportsJ9ulUSAu4cMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/reports.vue?macro=true";
import { default as _91id_93Mqnxnggg1uMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/roles/[id].vue?macro=true";
import { default as indexSha3XWBWhWMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/roles/index.vue?macro=true";
import { default as newRBXDCjcHf9Meta } from "/home/nodejs/kare-backoffice-v2/source/pages/roles/new.vue?macro=true";
import { default as sandboxEpgNenfjllMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/sandbox.vue?macro=true";
import { default as _91id_93PnYcZeIBJzMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/showrooms/[id].vue?macro=true";
import { default as index83sdb7BVDAMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/showrooms/index.vue?macro=true";
import { default as newN1F1vjumrMMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/showrooms/new.vue?macro=true";
import { default as _91id_93V0xLb9yScOMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/sitemaps/[id].vue?macro=true";
import { default as indexDfXD2CToZNMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/sitemaps/index.vue?macro=true";
import { default as newRPwSb5UQMvMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/sitemaps/new.vue?macro=true";
import { default as _91id_93oNRH2wRRCdMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/speed4trade/[id].vue?macro=true";
import { default as historyB955Oh5ZyxMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/speed4trade/history.vue?macro=true";
import { default as indexuwjvtFKW70Meta } from "/home/nodejs/kare-backoffice-v2/source/pages/speed4trade/index.vue?macro=true";
import { default as _91id_93mwbjYxrQIWMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/static-site-urls/[id].vue?macro=true";
import { default as indexCkazZNMcoNMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/static-site-urls/index.vue?macro=true";
import { default as newmJybp4Ei27Meta } from "/home/nodejs/kare-backoffice-v2/source/pages/static-site-urls/new.vue?macro=true";
import { default as customerT3b4mXR1i4Meta } from "/home/nodejs/kare-backoffice-v2/source/pages/statistics/customer.vue?macro=true";
import { default as ordersad1WzOAV1Meta } from "/home/nodejs/kare-backoffice-v2/source/pages/statistics/order.vue?macro=true";
import { default as _91id_93M5YmhpyAEfMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/stock-pools/[id].vue?macro=true";
import { default as indexVn41r8hmkeMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/stock-pools/index.vue?macro=true";
import { default as newyWQEkMrPseMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/stock-pools/new.vue?macro=true";
import { default as stock_45poolsLnrvRR82hfMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/stock-pools.vue?macro=true";
import { default as status_46selectcotHTJ7MdHMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/stock-source-file-downloads/filters/status.select.ts?macro=true";
import { default as stockPool_46selectJjlKui0W0OMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/stock-source-file-downloads/filters/stockPool.select.ts?macro=true";
import { default as stockSourceFile_46selectyuVMVMeNpcMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/stock-source-file-downloads/filters/stockSourceFile.select.ts?macro=true";
import { default as indexiQIezzzNMyMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/stock-source-file-downloads/index.vue?macro=true";
import { default as stock_45source_45file_45downloadseJApJslVQrMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/stock-source-file-downloads.vue?macro=true";
import { default as _91id_93MQU5SC2jGlMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/stock-source-files/[id].vue?macro=true";
import { default as indexnqb8mbJxYNMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/stock-source-files/index.vue?macro=true";
import { default as newqJWbyzhuQJMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/stock-source-files/new.vue?macro=true";
import { default as stock_45source_45filesmb4yfIVAfQMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/stock-source-files.vue?macro=true";
import { default as _91id_93xdkMc7FQcHMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/tags/[id].vue?macro=true";
import { default as index0tQ8MryWOqMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/tags/index.vue?macro=true";
import { default as newOpL76kPjmdMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/tags/new.vue?macro=true";
import { default as _91id_93A8TyG6njdlMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/taxes/[id].vue?macro=true";
import { default as indexsBrRAfn2ImMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/taxes/index.vue?macro=true";
import { default as newEKRt6O4875Meta } from "/home/nodejs/kare-backoffice-v2/source/pages/taxes/new.vue?macro=true";
import { default as taxesgBzEAhdGkGMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/taxes.vue?macro=true";
import { default as _91id_939WbJpMLKasMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/teasers/[id].vue?macro=true";
import { default as fallback_46toggleIFbCuuGA7GMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/teasers/fallback.toggle.ts?macro=true";
import { default as indexnuRbKbJQ32Meta } from "/home/nodejs/kare-backoffice-v2/source/pages/teasers/index.vue?macro=true";
import { default as isActive_46togglebrZVvNCXF0Meta } from "/home/nodejs/kare-backoffice-v2/source/pages/teasers/isActive.toggle.ts?macro=true";
import { default as newjOXt5I28ViMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/teasers/new.vue?macro=true";
import { default as _91id_93uuYngktUAfMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/templates/[id].vue?macro=true";
import { default as indexZ5gMMjLOfNMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/templates/index.vue?macro=true";
import { default as newxIENq2zTHqMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/templates/new.vue?macro=true";
import { default as templates91HnqPi0lSMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/templates.vue?macro=true";
import { default as bulkv11fhBy63aMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/translations/bulk.vue?macro=true";
import { default as glossary7l0Th3Q0lqMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/translations/glossary.vue?macro=true";
import { default as inboxMbjt5ysglJMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/translations/inbox.vue?macro=true";
import { default as indexcXyNv7MkOzMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/translations/index.vue?macro=true";
import { default as moduleGroupSelect_46inputWOOAHdSWFyMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/translations/inputs/moduleGroupSelect.input.ts?macro=true";
import { default as pageSelect_46inputLUZdXzRHkOMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/translations/inputs/pageSelect.input.ts?macro=true";
import { default as productSelect_46inputF5YOxAEwqPMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/translations/inputs/productSelect.input.ts?macro=true";
import { default as translationModelSelect_46input40p0vcZGT4Meta } from "/home/nodejs/kare-backoffice-v2/source/pages/translations/inputs/translationModelSelect.input.ts?macro=true";
import { default as _91id_93COSBzjNUvMMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/translations/jobs/[id].vue?macro=true";
import { default as indexZqBwvOyEWmMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/translations/jobs/index.vue?macro=true";
import { default as playground7u9duXcHS1Meta } from "/home/nodejs/kare-backoffice-v2/source/pages/translations/playground.vue?macro=true";
import { default as _91id_93QLQBECjq7VMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/translations/review/[id].vue?macro=true";
import { default as settingsddf3uF0RBxMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/translations/settings.vue?macro=true";
import { default as _91id_93nC4kOsPLCNMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/trendshows/[id].vue?macro=true";
import { default as indexXnLr3pd1anMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/trendshows/index.vue?macro=true";
import { default as newsmaVpWNXOgMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/trendshows/new.vue?macro=true";
import { default as index0zZSfOBjtXMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/user-events/index.vue?macro=true";
import { default as user_45eventsnv197N6yShMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/user-events.vue?macro=true";
import { default as _91id_93YI2c6Gt7VXMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/users/[id].vue?macro=true";
import { default as indexaGFOJxGaNnMeta } from "/home/nodejs/kare-backoffice-v2/source/pages/users/index.vue?macro=true";
export default [
  {
    name: "403",
    path: "/403",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/403.vue").then(m => m.default || m)
  },
  {
    name: "assistant-ai-product-data-generation",
    path: "/assistant/ai-product-data-generation",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/assistant/ai-product-data-generation.vue").then(m => m.default || m)
  },
  {
    name: "assistant-ai-product-data-purge",
    path: "/assistant/ai-product-data-purge",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/assistant/ai-product-data-purge.vue").then(m => m.default || m)
  },
  {
    name: ai_45product_45data_45reviewcIHRxlH4y1Meta?.name,
    path: "/assistant/ai-product-data-review",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/assistant/ai-product-data-review.vue").then(m => m.default || m),
    children: [
  {
    name: "assistant-ai-product-data-review-id",
    path: ":id()",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/assistant/ai-product-data-review/[id].vue").then(m => m.default || m)
  },
  {
    name: "assistant-ai-product-data-review",
    path: "",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/assistant/ai-product-data-review/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "assistant-ai-product-data-id",
    path: "/assistant/ai-product-data/:id()",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/assistant/ai-product-data/[id].vue").then(m => m.default || m)
  },
  {
    name: "assistant-ai-product-data",
    path: "/assistant/ai-product-data",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/assistant/ai-product-data/index.vue").then(m => m.default || m)
  },
  {
    name: "assistant-inputs-assistantAttributesSelect.input",
    path: "/assistant/inputs/assistantAttributesSelect.input",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/assistant/inputs/assistantAttributesSelect.input.ts").then(m => m.default || m)
  },
  {
    name: attribute_45groupsuFAbBl00P4Meta?.name,
    path: "/attribute-groups",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/attribute-groups.vue").then(m => m.default || m),
    children: [
  {
    name: "attribute-groups-id",
    path: ":id()",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/attribute-groups/[id].vue").then(m => m.default || m)
  },
  {
    name: "attribute-groups",
    path: "",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/attribute-groups/index.vue").then(m => m.default || m)
  },
  {
    name: "attribute-groups-new",
    path: "new",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/attribute-groups/new.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "attributes-id-attribute-values-lang",
    path: "/attributes/:id()/attribute-values/:lang()",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/attributes/[id]/attribute-values/[lang].vue").then(m => m.default || m)
  },
  {
    name: "attributes-id",
    path: "/attributes/:id()",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/attributes/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: "attributes",
    path: "/attributes",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/attributes/index.vue").then(m => m.default || m)
  },
  {
    name: "authors-id",
    path: "/authors/:id()",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/authors/[id].vue").then(m => m.default || m)
  },
  {
    name: "authors",
    path: "/authors",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/authors/index.vue").then(m => m.default || m)
  },
  {
    name: "authors-new",
    path: "/authors/new",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/authors/new.vue").then(m => m.default || m)
  },
  {
    name: "baselinker",
    path: "/baselinker",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/baselinker/index.vue").then(m => m.default || m)
  },
  {
    name: "basketsim",
    path: "/basketsim",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/basketsim.vue").then(m => m.default || m)
  },
  {
    name: bi_45centereeXeomSTGiMeta?.name,
    path: "/bi-center",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/bi-center.vue").then(m => m.default || m),
    children: [
  {
    name: "bi-center-filters-adspend-toggle",
    path: "filters/adspend-toggle",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/bi-center/filters/adspend-toggle.ts").then(m => m.default || m)
  },
  {
    name: "bi-center-filters-fast-delivery-toggle",
    path: "filters/fast-delivery-toggle",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/bi-center/filters/fast-delivery-toggle.ts").then(m => m.default || m)
  },
  {
    name: "bi-center-filters-metric-date",
    path: "filters/metric-date",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/bi-center/filters/metric-date.ts").then(m => m.default || m)
  },
  {
    name: "bi-center",
    path: "",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/bi-center/index.vue").then(m => m.default || m)
  },
  {
    name: "bi-center-manufacturer-margins",
    path: "manufacturer-margins",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/bi-center/manufacturer-margins.vue").then(m => m.default || m)
  },
  {
    name: "bi-center-manufacturers",
    path: "manufacturers",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/bi-center/manufacturers.vue").then(m => m.default || m)
  },
  {
    name: "bi-center-margin-checks",
    path: "margin-checks",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/bi-center/margin-checks.vue").then(m => m.default || m)
  },
  {
    name: "bi-center-metrics-values",
    path: "metrics-values",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/bi-center/metrics-values.vue").then(m => m.default || m)
  },
  {
    name: "bi-center-performance-stocks",
    path: "performance-stocks",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/bi-center/performance-stocks.vue").then(m => m.default || m)
  },
  {
    name: "bi-center-poas",
    path: "poas",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/bi-center/poas.vue").then(m => m.default || m)
  },
  {
    name: "bi-center-product-metrics",
    path: "product-metrics",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/bi-center/product-metrics.vue").then(m => m.default || m)
  },
  {
    name: "bi-center-product-poas-productId-channelId",
    path: "product-poas/:productId()-:channelId()",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/bi-center/product-poas/[productId]-[channelId].vue").then(m => m.default || m)
  },
  {
    name: "bi-center-product-poas",
    path: "product-poas",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/bi-center/product-poas/index.vue").then(m => m.default || m)
  },
  {
    name: "bi-center-stats",
    path: "stats",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/bi-center/stats.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "cache",
    path: "/cache",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/cache/index.vue").then(m => m.default || m)
  },
  {
    name: "campaigns-id",
    path: "/campaigns/:id()",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/campaigns/[id].vue").then(m => m.default || m)
  },
  {
    name: "campaigns",
    path: "/campaigns",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/campaigns/index.vue").then(m => m.default || m)
  },
  {
    name: "campaigns-new",
    path: "/campaigns/new",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/campaigns/new.vue").then(m => m.default || m)
  },
  {
    name: carrierszQjHGcMwbHMeta?.name,
    path: "/carriers",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/carriers.vue").then(m => m.default || m),
    children: [
  {
    name: "carriers-id",
    path: ":id()",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/carriers/[id].vue").then(m => m.default || m)
  },
  {
    name: "carriers",
    path: "",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/carriers/index.vue").then(m => m.default || m)
  },
  {
    name: "carriers-new",
    path: "new",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/carriers/new.vue").then(m => m.default || m)
  }
]
  },
  {
    name: categoriesUA8VD2kCmaMeta?.name,
    path: "/categories",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/categories.vue").then(m => m.default || m),
    children: [
  {
    name: "categories-id",
    path: ":id()",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/categories/[id].vue").then(m => m.default || m)
  },
  {
    name: "categories-clone-tree",
    path: "clone-tree",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/categories/clone-tree.vue").then(m => m.default || m)
  },
  {
    name: "categories-filters-active.select",
    path: "filters/active.select",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/categories/filters/active.select.ts").then(m => m.default || m)
  },
  {
    name: "categories-filters-emptyDescription.toggle",
    path: "filters/emptyDescription.toggle",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/categories/filters/emptyDescription.toggle.ts").then(m => m.default || m)
  },
  {
    name: "categories-filters-emptyHeaderImage.select",
    path: "filters/emptyHeaderImage.select",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/categories/filters/emptyHeaderImage.select.ts").then(m => m.default || m)
  },
  {
    name: "categories-filters-emptyName.select",
    path: "filters/emptyName.select",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/categories/filters/emptyName.select.ts").then(m => m.default || m)
  },
  {
    name: "categories-filters-emptyProductFilters.select",
    path: "filters/emptyProductFilters.select",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/categories/filters/emptyProductFilters.select.ts").then(m => m.default || m)
  },
  {
    name: "categories-filters-emptySateliteDesc.select",
    path: "filters/emptySateliteDesc.select",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/categories/filters/emptySateliteDesc.select.ts").then(m => m.default || m)
  },
  {
    name: "categories-filters-emptySeoDesc.toggle",
    path: "filters/emptySeoDesc.toggle",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/categories/filters/emptySeoDesc.toggle.ts").then(m => m.default || m)
  },
  {
    name: "categories-filters-emptySeoTitle.toggle",
    path: "filters/emptySeoTitle.toggle",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/categories/filters/emptySeoTitle.toggle.ts").then(m => m.default || m)
  },
  {
    name: "categories-filters-excludeFromAutoComplete.select",
    path: "filters/excludeFromAutoComplete.select",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/categories/filters/excludeFromAutoComplete.select.ts").then(m => m.default || m)
  },
  {
    name: "categories-filters-query.select",
    path: "filters/query.select",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/categories/filters/query.select.ts").then(m => m.default || m)
  },
  {
    name: "categories-filters-sort.select",
    path: "filters/sort.select",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/categories/filters/sort.select.ts").then(m => m.default || m)
  },
  {
    name: "categories-filters-status.select",
    path: "filters/status.select",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/categories/filters/status.select.ts").then(m => m.default || m)
  },
  {
    name: "categories-filters-virtual.select",
    path: "filters/virtual.select",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/categories/filters/virtual.select.ts").then(m => m.default || m)
  },
  {
    name: "categories-filters-visibility.select",
    path: "filters/visibility.select",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/categories/filters/visibility.select.ts").then(m => m.default || m)
  },
  {
    name: "categories",
    path: "",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/categories/index.vue").then(m => m.default || m)
  },
  {
    name: "categories-inputs-categoryAttributes.input",
    path: "inputs/categoryAttributes.input",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/categories/inputs/categoryAttributes.input.ts").then(m => m.default || m)
  },
  {
    name: "categories-inputs-categoryTree.input",
    path: "inputs/categoryTree.input",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/categories/inputs/categoryTree.input.ts").then(m => m.default || m)
  },
  {
    name: "categories-mappings",
    path: "mappings",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/categories/mappings.vue").then(m => m.default || m)
  },
  {
    name: "categories-new",
    path: "new",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/categories/new.vue").then(m => m.default || m)
  },
  {
    name: "categories-product-sorting-id",
    path: "product-sorting/:id()",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/categories/product-sorting/[id].vue").then(m => m.default || m)
  },
  {
    name: "categories-tree",
    path: "tree",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/categories/tree.vue").then(m => m.default || m)
  },
  {
    name: "categories-virtual-categories",
    path: "virtual-categories",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/categories/virtual-categories/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: channels4cZpwXLboqMeta?.name,
    path: "/channels",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/channels.vue").then(m => m.default || m),
    children: [
  {
    name: "channels-id",
    path: ":id()",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/channels/[id].vue").then(m => m.default || m)
  },
  {
    name: "channels-filters-available.select",
    path: "filters/available.select",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/channels/filters/available.select.ts").then(m => m.default || m)
  },
  {
    name: "channels-filters-hasMapping.select",
    path: "filters/hasMapping.select",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/channels/filters/hasMapping.select.ts").then(m => m.default || m)
  },
  {
    name: "channels",
    path: "",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/channels/index.vue").then(m => m.default || m)
  },
  {
    name: "channels-inputs-fisEnabled.toggle",
    path: "inputs/fisEnabled.toggle",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/channels/inputs/fisEnabled.toggle.ts").then(m => m.default || m)
  },
  {
    name: "channels-inputs-overwrite.toggle",
    path: "inputs/overwrite.toggle",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/channels/inputs/overwrite.toggle.ts").then(m => m.default || m)
  },
  {
    name: "channels-inputs-productsStatus.input",
    path: "inputs/productsStatus.input",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/channels/inputs/productsStatus.input.ts").then(m => m.default || m)
  },
  {
    name: "channels-inputs-sitemaps.inputs",
    path: "inputs/sitemaps.inputs",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/channels/inputs/sitemaps.inputs.ts").then(m => m.default || m)
  },
  {
    name: "channels-inputs-type.input",
    path: "inputs/type.input",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/channels/inputs/type.input.ts").then(m => m.default || m)
  },
  {
    name: "channels-migration",
    path: "migration",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/channels/migration.vue").then(m => m.default || m)
  },
  {
    name: "channels-new",
    path: "new",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/channels/new.vue").then(m => m.default || m)
  },
  {
    name: "channels-remote-categories",
    path: "remote-categories",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/channels/remote-categories.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "collections-id",
    path: "/collections/:id()",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/collections/[id].vue").then(m => m.default || m)
  },
  {
    name: "collections",
    path: "/collections",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/collections/index.vue").then(m => m.default || m)
  },
  {
    name: "collections-new",
    path: "/collections/new",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/collections/new.vue").then(m => m.default || m)
  },
  {
    name: "countries-id",
    path: "/countries/:id()",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/countries/[id].vue").then(m => m.default || m)
  },
  {
    name: "countries",
    path: "/countries",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/countries/index.vue").then(m => m.default || m)
  },
  {
    name: "countries-new",
    path: "/countries/new",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/countries/new.vue").then(m => m.default || m)
  },
  {
    name: currenciesnhAZw5m04wMeta?.name,
    path: "/currencies",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/currencies.vue").then(m => m.default || m),
    children: [
  {
    name: "currencies-id",
    path: ":id()",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/currencies/[id].vue").then(m => m.default || m)
  },
  {
    name: "currencies",
    path: "",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/currencies/index.vue").then(m => m.default || m)
  },
  {
    name: "currencies-new",
    path: "new",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/currencies/new.vue").then(m => m.default || m)
  }
]
  },
  {
    name: customer_45groupslhugwLOFepMeta?.name,
    path: "/customer-groups",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/customer-groups.vue").then(m => m.default || m),
    children: [
  {
    name: "customer-groups-id",
    path: ":id()",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/customer-groups/[id].vue").then(m => m.default || m)
  },
  {
    name: "customer-groups",
    path: "",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/customer-groups/index.vue").then(m => m.default || m)
  },
  {
    name: "customer-groups-new",
    path: "new",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/customer-groups/new.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "customers-customer-mail",
    path: "/customers/:customer()/mail",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/customers/[customer]/mail.vue").then(m => m.default || m)
  },
  {
    name: "customers-customer-messages-message",
    path: "/customers/:customer()/messages/:message()",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/customers/[customer]/messages/[message].vue").then(m => m.default || m)
  },
  {
    name: "customers-id",
    path: "/customers/:id()",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/customers/[id].vue").then(m => m.default || m)
  },
  {
    name: "customers",
    path: "/customers",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/customers/index.vue").then(m => m.default || m)
  },
  {
    name: "customers-inputs-isMarketingAccepted.toggle",
    path: "/customers/inputs/isMarketingAccepted.toggle",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/customers/inputs/isMarketingAccepted.toggle.ts").then(m => m.default || m)
  },
  {
    name: "customers-inputs-isMarketingSubscribed.toggle",
    path: "/customers/inputs/isMarketingSubscribed.toggle",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/customers/inputs/isMarketingSubscribed.toggle.ts").then(m => m.default || m)
  },
  {
    name: "customers-inputs-isTermsAccepted.toggle",
    path: "/customers/inputs/isTermsAccepted.toggle",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/customers/inputs/isTermsAccepted.toggle.ts").then(m => m.default || m)
  },
  {
    name: "customers-new",
    path: "/customers/new",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/customers/new.vue").then(m => m.default || m)
  },
  {
    name: "delivery-methods-id",
    path: "/delivery-methods/:id()",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/delivery-methods/[id].vue").then(m => m.default || m)
  },
  {
    name: "delivery-methods",
    path: "/delivery-methods",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/delivery-methods/index.vue").then(m => m.default || m)
  },
  {
    name: "delivery-methods-new",
    path: "/delivery-methods/new",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/delivery-methods/new.vue").then(m => m.default || m)
  },
  {
    name: "delivery-methods-services-id",
    path: "/delivery-methods/services/:id()",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/delivery-methods/services/[id].vue").then(m => m.default || m)
  },
  {
    name: "delivery-methods-services",
    path: "/delivery-methods/services",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/delivery-methods/services/index.vue").then(m => m.default || m)
  },
  {
    name: "delivery-methods-services-new",
    path: "/delivery-methods/services/new",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/delivery-methods/services/new.vue").then(m => m.default || m)
  },
  {
    name: exportsHyYOr79BNEMeta?.name,
    path: "/exports",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/exports.vue").then(m => m.default || m),
    children: [
  {
    name: "exports-id",
    path: ":id()",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/exports/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: "exports-id-stats",
    path: ":id()/stats",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/exports/[id]/stats.vue").then(m => m.default || m)
  },
  {
    name: "exports-debug",
    path: "debug",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/exports/debug/index.vue").then(m => m.default || m)
  },
  {
    name: "exports",
    path: "",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/exports/index.vue").then(m => m.default || m)
  },
  {
    name: "exports-model",
    path: "model",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/exports/model.ts").then(m => m.default || m)
  },
  {
    name: "exports-new-id",
    path: "new/:id()",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/exports/new/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: "exports-new",
    path: "new",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/exports/new/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: flagsqZBMFpC7DHMeta?.name,
    path: "/flags",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/flags.vue").then(m => m.default || m),
    children: [
  {
    name: "flags-id",
    path: ":id()",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/flags/[id].vue").then(m => m.default || m)
  },
  {
    name: "flags",
    path: "",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/flags/index.vue").then(m => m.default || m)
  },
  {
    name: "flags-inputs-isHidden.input",
    path: "inputs/isHidden.input",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/flags/inputs/isHidden.input.ts").then(m => m.default || m)
  },
  {
    name: "flags-new",
    path: "new",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/flags/new.vue").then(m => m.default || m)
  }
]
  },
  {
    name: image_45studioa5ZPRQRtFjMeta?.name,
    path: "/image-studio",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/image-studio.vue").then(m => m.default || m),
    children: [
  {
    name: "image-studio",
    path: "",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/image-studio/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "imports-id",
    path: "/imports/:id()",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/imports/[id].vue").then(m => m.default || m)
  },
  {
    name: "imports-filters-import-type.select",
    path: "/imports/filters/import-type.select",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/imports/filters/import-type.select.ts").then(m => m.default || m)
  },
  {
    name: "imports-filters-parent-import.select",
    path: "/imports/filters/parent-import.select",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/imports/filters/parent-import.select.ts").then(m => m.default || m)
  },
  {
    name: "imports-filters-status.select",
    path: "/imports/filters/status.select",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/imports/filters/status.select.ts").then(m => m.default || m)
  },
  {
    name: "imports-import-rows-id",
    path: "/imports/import-rows/:id()",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/imports/import-rows/[id].vue").then(m => m.default || m)
  },
  {
    name: "imports-import-rows-filters-status.select",
    path: "/imports/import-rows/filters/status.select",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/imports/import-rows/filters/status.select.ts").then(m => m.default || m)
  },
  {
    name: "imports",
    path: "/imports",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/imports/index.vue").then(m => m.default || m)
  },
  {
    name: "imports-new-old",
    path: "/imports/new-old",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/imports/new-old.vue").then(m => m.default || m)
  },
  {
    name: "imports-new-id",
    path: "/imports/new/:id()",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/imports/new/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: "imports-new",
    path: "/imports/new",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/imports/new/index.vue").then(m => m.default || m)
  },
  {
    name: "index",
    path: "/",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "inspiration-images-id",
    path: "/inspiration-images/:id()",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/inspiration-images/[id].vue").then(m => m.default || m)
  },
  {
    name: "inspiration-images",
    path: "/inspiration-images",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/inspiration-images/index.vue").then(m => m.default || m)
  },
  {
    name: "inspiration-images-new",
    path: "/inspiration-images/new",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/inspiration-images/new.vue").then(m => m.default || m)
  },
  {
    name: inspirationsI3NEfSTeYpMeta?.name,
    path: "/inspirations",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/inspirations.vue").then(m => m.default || m),
    children: [
  {
    name: "inspirations-id",
    path: ":id()",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/inspirations/[id].vue").then(m => m.default || m)
  },
  {
    name: "inspirations",
    path: "",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/inspirations/index.vue").then(m => m.default || m)
  },
  {
    name: "inspirations-new",
    path: "new",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/inspirations/new.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "integrations-hq-stock",
    path: "/integrations/hq-stock",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/integrations/hq-stock/index.vue").then(m => m.default || m)
  },
  {
    name: "integrations",
    path: "/integrations",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/integrations/index.vue").then(m => m.default || m)
  },
  {
    name: "integrations-kare-tracking",
    path: "/integrations/kare-tracking",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/integrations/kare-tracking/index.vue").then(m => m.default || m)
  },
  {
    name: "internal-product-index",
    path: "/internal/product-index",
    meta: indexu59lH9Pye2Meta || {},
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/internal/product-index/index.vue").then(m => m.default || m)
  },
  {
    name: "jobs-filters-status.select",
    path: "/jobs/filters/status.select",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/jobs/filters/status.select.ts").then(m => m.default || m)
  },
  {
    name: "jobs-filters-types.select",
    path: "/jobs/filters/types.select",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/jobs/filters/types.select.ts").then(m => m.default || m)
  },
  {
    name: "jobs",
    path: "/jobs",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/jobs/index.vue").then(m => m.default || m)
  },
  {
    name: "knowledge-base",
    path: "/knowledge-base",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/knowledge-base.vue").then(m => m.default || m)
  },
  {
    name: "languages-id",
    path: "/languages/:id()",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/languages/[id].vue").then(m => m.default || m)
  },
  {
    name: "languages",
    path: "/languages",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/languages/index.vue").then(m => m.default || m)
  },
  {
    name: "languages-new",
    path: "/languages/new",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/languages/new.vue").then(m => m.default || m)
  },
  {
    name: "links-id",
    path: "/links/:id()",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/links/[id].vue").then(m => m.default || m)
  },
  {
    name: "links",
    path: "/links",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/links/index.vue").then(m => m.default || m)
  },
  {
    name: "links-new",
    path: "/links/new",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/links/new.vue").then(m => m.default || m)
  },
  {
    name: "listing-dividers-id",
    path: "/listing-dividers/:id()",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/listing-dividers/[id].vue").then(m => m.default || m)
  },
  {
    name: "listing-dividers",
    path: "/listing-dividers",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/listing-dividers/index.vue").then(m => m.default || m)
  },
  {
    name: "listing-dividers-new",
    path: "/listing-dividers/new",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/listing-dividers/new.vue").then(m => m.default || m)
  },
  {
    name: "login",
    path: "/login",
    meta: loginJbQ990ojpbMeta || {},
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/login.vue").then(m => m.default || m)
  },
  {
    name: "logout",
    path: "/logout",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/logout.vue").then(m => m.default || m)
  },
  {
    name: "mailchimp-list-configs-id",
    path: "/mailchimp-list-configs/:id()",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/mailchimp-list-configs/[id].vue").then(m => m.default || m)
  },
  {
    name: "mailchimp-list-configs",
    path: "/mailchimp-list-configs",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/mailchimp-list-configs/index.vue").then(m => m.default || m)
  },
  {
    name: "mailchimp-list-configs-new",
    path: "/mailchimp-list-configs/new",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/mailchimp-list-configs/new.vue").then(m => m.default || m)
  },
  {
    name: manufacturer_45deliverieshMNtv1Ddj1Meta?.name,
    path: "/manufacturer-deliveries",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/manufacturer-deliveries.vue").then(m => m.default || m),
    children: [
  {
    name: "manufacturer-deliveries-id",
    path: ":id()",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/manufacturer-deliveries/[id].vue").then(m => m.default || m)
  },
  {
    name: "manufacturer-deliveries-bulk-create",
    path: "bulk-create",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/manufacturer-deliveries/bulk-create/index.vue").then(m => m.default || m)
  },
  {
    name: "manufacturer-deliveries-bulk-create-inputs-dayOfWeekSelect.input",
    path: "bulk-create/inputs/dayOfWeekSelect.input",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/manufacturer-deliveries/bulk-create/inputs/dayOfWeekSelect.input.ts").then(m => m.default || m)
  },
  {
    name: "manufacturer-deliveries-bulk-create-inputs-periodSelect.input",
    path: "bulk-create/inputs/periodSelect.input",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/manufacturer-deliveries/bulk-create/inputs/periodSelect.input.ts").then(m => m.default || m)
  },
  {
    name: "manufacturer-deliveries-bulk-delete",
    path: "bulk-delete",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/manufacturer-deliveries/bulk-delete/index.vue").then(m => m.default || m)
  },
  {
    name: "manufacturer-deliveries",
    path: "",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/manufacturer-deliveries/index.vue").then(m => m.default || m)
  },
  {
    name: "manufacturer-deliveries-new",
    path: "new",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/manufacturer-deliveries/new.vue").then(m => m.default || m)
  }
]
  },
  {
    name: manufacturerso0APnhraqeMeta?.name,
    path: "/manufacturers",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/manufacturers.vue").then(m => m.default || m),
    children: [
  {
    name: "manufacturers-id",
    path: ":id()",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/manufacturers/[id].vue").then(m => m.default || m)
  },
  {
    name: "manufacturers",
    path: "",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/manufacturers/index.vue").then(m => m.default || m)
  },
  {
    name: "manufacturers-new",
    path: "new",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/manufacturers/new.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "meble",
    path: "/meble",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/meble/index.vue").then(m => m.default || m)
  },
  {
    name: "menu-id",
    path: "/menu/:id()",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/menu/[id].vue").then(m => m.default || m)
  },
  {
    name: "menu",
    path: "/menu",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/menu/index.vue").then(m => m.default || m)
  },
  {
    name: "menu-inputs-layout.input",
    path: "/menu/inputs/layout.input",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/menu/inputs/layout.input.ts").then(m => m.default || m)
  },
  {
    name: "menu-inputs-type.input",
    path: "/menu/inputs/type.input",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/menu/inputs/type.input.ts").then(m => m.default || m)
  },
  {
    name: "menu-new",
    path: "/menu/new",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/menu/new.vue").then(m => m.default || m)
  },
  {
    name: "menu-utils",
    path: "/menu/utils",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/menu/utils.ts").then(m => m.default || m)
  },
  {
    name: module_45groupseaZzp3hfnwMeta?.name,
    path: "/module-groups",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/module-groups.vue").then(m => m.default || m),
    children: [
  {
    name: "module-groups-id",
    path: ":id()",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/module-groups/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: "module-groups-id-modules-_type",
    path: ":id()/modules/_:type()",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/module-groups/[id]/modules/_[type].vue").then(m => m.default || m)
  },
  {
    name: "module-groups-id-modules-moduleId",
    path: ":id()/modules/:moduleId()",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/module-groups/[id]/modules/[moduleId].vue").then(m => m.default || m)
  },
  {
    name: "module-groups-id-modules-edit-moduleId-type",
    path: ":id()/modules/edit/:moduleId()/:type()",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/module-groups/[id]/modules/edit/[moduleId]/[type].vue").then(m => m.default || m)
  },
  {
    name: "module-groups-id-modules-new-type",
    path: ":id()/modules/new/:type()",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/module-groups/[id]/modules/new/[type].vue").then(m => m.default || m)
  },
  {
    name: "module-groups-id-modules-new",
    path: ":id()/modules/new",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/module-groups/[id]/modules/new/index.vue").then(m => m.default || m)
  },
  {
    name: "module-groups",
    path: "",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/module-groups/index.vue").then(m => m.default || m)
  },
  {
    name: "module-groups-new",
    path: "new",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/module-groups/new.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "order-statuses-id",
    path: "/order-statuses/:id()",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/order-statuses/[id].vue").then(m => m.default || m)
  },
  {
    name: "order-statuses-filters-default-status.toggle",
    path: "/order-statuses/filters/default-status.toggle",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/order-statuses/filters/default-status.toggle.ts").then(m => m.default || m)
  },
  {
    name: "order-statuses",
    path: "/order-statuses",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/order-statuses/index.vue").then(m => m.default || m)
  },
  {
    name: "order-statuses-new",
    path: "/order-statuses/new",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/order-statuses/new.vue").then(m => m.default || m)
  },
  {
    name: ordersyEkRSkcLjIMeta?.name,
    path: "/orders",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/orders.vue").then(m => m.default || m),
    children: [
  {
    name: "orders-id",
    path: ":id()",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/orders/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: "orders-id-messages-message",
    path: ":id()/messages/:message()",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/orders/[id]/messages/[message].vue").then(m => m.default || m)
  },
  {
    name: "orders",
    path: "",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/orders/index.vue").then(m => m.default || m)
  },
  {
    name: "orders-new",
    path: "new",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/orders/new.vue").then(m => m.default || m)
  },
  {
    name: "orders-pending-shipments",
    path: "pending-shipments",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/orders/pending-shipments/index.vue").then(m => m.default || m)
  },
  {
    name: "orders-promised-deliveries",
    path: "promised-deliveries",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/orders/promised-deliveries/index.vue").then(m => m.default || m)
  },
  {
    name: "orders-shd-mappings",
    path: "shd-mappings",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/orders/shd-mappings/index.vue").then(m => m.default || m)
  },
  {
    name: "orders-shd-mappings-new",
    path: "shd-mappings/new",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/orders/shd-mappings/new.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "pages-id",
    path: "/pages/:id()",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/pages/[id].vue").then(m => m.default || m)
  },
  {
    name: "pages",
    path: "/pages",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "pages-new",
    path: "/pages/new",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/pages/new.vue").then(m => m.default || m)
  },
  {
    name: "partners-id",
    path: "/partners/:id()",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/partners/[id].vue").then(m => m.default || m)
  },
  {
    name: "partners",
    path: "/partners",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/partners/index.vue").then(m => m.default || m)
  },
  {
    name: "partners-new",
    path: "/partners/new",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/partners/new.vue").then(m => m.default || m)
  },
  {
    name: "payment-methods-id",
    path: "/payment-methods/:id()",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/payment-methods/[id].vue").then(m => m.default || m)
  },
  {
    name: "payment-methods",
    path: "/payment-methods",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/payment-methods/index.vue").then(m => m.default || m)
  },
  {
    name: "payment-methods-new",
    path: "/payment-methods/new",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/payment-methods/new.vue").then(m => m.default || m)
  },
  {
    name: "payment-methods-schemas-adyen",
    path: "/payment-methods/schemas/adyen",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/payment-methods/schemas/adyen.ts").then(m => m.default || m)
  },
  {
    name: "payment-methods-schemas-borica",
    path: "/payment-methods/schemas/borica",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/payment-methods/schemas/borica.ts").then(m => m.default || m)
  },
  {
    name: "payment-methods-schemas-fibank",
    path: "/payment-methods/schemas/fibank",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/payment-methods/schemas/fibank.ts").then(m => m.default || m)
  },
  {
    name: "payment-methods-schemas-imoje",
    path: "/payment-methods/schemas/imoje",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/payment-methods/schemas/imoje.ts").then(m => m.default || m)
  },
  {
    name: "payment-methods-schemas",
    path: "/payment-methods/schemas",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/payment-methods/schemas/index.ts").then(m => m.default || m)
  },
  {
    name: "payment-methods-schemas-intensa",
    path: "/payment-methods/schemas/intensa",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/payment-methods/schemas/intensa.ts").then(m => m.default || m)
  },
  {
    name: "payment-methods-schemas-iyzico",
    path: "/payment-methods/schemas/iyzico",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/payment-methods/schemas/iyzico.ts").then(m => m.default || m)
  },
  {
    name: "payment-methods-schemas-kh",
    path: "/payment-methods/schemas/kh",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/payment-methods/schemas/kh.ts").then(m => m.default || m)
  },
  {
    name: "payment-methods-schemas-klarna",
    path: "/payment-methods/schemas/klarna",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/payment-methods/schemas/klarna.ts").then(m => m.default || m)
  },
  {
    name: "payment-methods-schemas-kustom",
    path: "/payment-methods/schemas/kustom",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/payment-methods/schemas/kustom.ts").then(m => m.default || m)
  },
  {
    name: "payment-methods-schemas-neopay",
    path: "/payment-methods/schemas/neopay",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/payment-methods/schemas/neopay.ts").then(m => m.default || m)
  },
  {
    name: "payment-methods-schemas-paymentez",
    path: "/payment-methods/schemas/paymentez",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/payment-methods/schemas/paymentez.ts").then(m => m.default || m)
  },
  {
    name: "payment-methods-schemas-paynl",
    path: "/payment-methods/schemas/paynl",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/payment-methods/schemas/paynl.ts").then(m => m.default || m)
  },
  {
    name: "payment-methods-schemas-paypo",
    path: "/payment-methods/schemas/paypo",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/payment-methods/schemas/paypo.ts").then(m => m.default || m)
  },
  {
    name: "payment-methods-schemas-payu",
    path: "/payment-methods/schemas/payu",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/payment-methods/schemas/payu.ts").then(m => m.default || m)
  },
  {
    name: "payment-methods-schemas-payuv4",
    path: "/payment-methods/schemas/payuv4",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/payment-methods/schemas/payuv4.ts").then(m => m.default || m)
  },
  {
    name: "payment-methods-schemas-powertranz",
    path: "/payment-methods/schemas/powertranz",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/payment-methods/schemas/powertranz.ts").then(m => m.default || m)
  },
  {
    name: "payment-methods-schemas-wirecard",
    path: "/payment-methods/schemas/wirecard",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/payment-methods/schemas/wirecard.ts").then(m => m.default || m)
  },
  {
    name: "payment-methods-schemas-wspay",
    path: "/payment-methods/schemas/wspay",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/payment-methods/schemas/wspay.ts").then(m => m.default || m)
  },
  {
    name: "payment-methods-webhooks",
    path: "/payment-methods/webhooks",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/payment-methods/webhooks.vue").then(m => m.default || m)
  },
  {
    name: "printer",
    path: "/printer",
    meta: printerxfVQHaXeHyMeta || {},
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/printer.vue").then(m => m.default || m)
  },
  {
    name: product_45familieszPSASkY2GWMeta?.name,
    path: "/product-families",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/product-families.vue").then(m => m.default || m),
    children: [
  {
    name: "product-families-id",
    path: ":id()",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/product-families/[id].vue").then(m => m.default || m)
  },
  {
    name: "product-families",
    path: "",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/product-families/index.vue").then(m => m.default || m)
  },
  {
    name: "product-families-new",
    path: "new",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/product-families/new.vue").then(m => m.default || m)
  }
]
  },
  {
    name: product_45filters5HUX3W1bvYMeta?.name,
    path: "/product-filters",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/product-filters.vue").then(m => m.default || m),
    children: [
  {
    name: "product-filters-id",
    path: ":id()",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/product-filters/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: "product-filters-id-sort",
    path: ":id()/sort",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/product-filters/[id]/sort.vue").then(m => m.default || m)
  },
  {
    name: "product-filters-id-stats",
    path: ":id()/stats",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/product-filters/[id]/stats.vue").then(m => m.default || m)
  },
  {
    name: "product-filters",
    path: "",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/product-filters/index.vue").then(m => m.default || m)
  },
  {
    name: "product-filters-new",
    path: "new",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/product-filters/new.vue").then(m => m.default || m)
  },
  {
    name: "product-filters-product-filter-results",
    path: "product-filter-results",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/product-filters/product-filter-results/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "product-stock-logs",
    path: "/product-stock-logs",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/product-stock-logs/index.vue").then(m => m.default || m)
  },
  {
    name: product_45stocks1Zi5M8JzN3Meta?.name,
    path: "/product-stocks",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/product-stocks.vue").then(m => m.default || m),
    children: [
  {
    name: "product-stocks-debug",
    path: "debug",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/product-stocks/debug/index.vue").then(m => m.default || m)
  },
  {
    name: "product-stocks",
    path: "",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/product-stocks/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: productsZ2XmSPOuSpMeta?.name,
    path: "/products",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/products.vue").then(m => m.default || m),
    children: [
  {
    name: "products-id",
    path: ":id()",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/products/[id].vue").then(m => m.default || m)
  },
  {
    name: "products-configurator-groups-id",
    path: "configurator-groups/:id()",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/products/configurator-groups/[id].vue").then(m => m.default || m)
  },
  {
    name: "products-configurator-groups",
    path: "configurator-groups",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/products/configurator-groups/index.vue").then(m => m.default || m)
  },
  {
    name: "products-configurator-groups-new",
    path: "configurator-groups/new",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/products/configurator-groups/new.vue").then(m => m.default || m)
  },
  {
    name: "products-coupons-info-box-id",
    path: "coupons-info-box/:id()",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/products/coupons-info-box/[id].vue").then(m => m.default || m)
  },
  {
    name: "products-coupons-info-box",
    path: "coupons-info-box",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/products/coupons-info-box/index.vue").then(m => m.default || m)
  },
  {
    name: "products-coupons-info-box-new",
    path: "coupons-info-box/new",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/products/coupons-info-box/new.vue").then(m => m.default || m)
  },
  {
    name: "products-coupons-id",
    path: "coupons/:id()",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/products/coupons/[id].vue").then(m => m.default || m)
  },
  {
    name: "products-coupons",
    path: "coupons",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/products/coupons/index.vue").then(m => m.default || m)
  },
  {
    name: "products-coupons-inputs-checkPrefix.toggle",
    path: "coupons/inputs/checkPrefix.toggle",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/products/coupons/inputs/checkPrefix.toggle.ts").then(m => m.default || m)
  },
  {
    name: "products-coupons-inputs-discountedApplicable.toggle",
    path: "coupons/inputs/discountedApplicable.toggle",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/products/coupons/inputs/discountedApplicable.toggle.ts").then(m => m.default || m)
  },
  {
    name: "products-coupons-inputs-highestDiscount.toggle",
    path: "coupons/inputs/highestDiscount.toggle",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/products/coupons/inputs/highestDiscount.toggle.ts").then(m => m.default || m)
  },
  {
    name: "products-coupons-inputs-isFreeDelivery.toggle",
    path: "coupons/inputs/isFreeDelivery.toggle",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/products/coupons/inputs/isFreeDelivery.toggle.ts").then(m => m.default || m)
  },
  {
    name: "products-coupons-inputs-loggedInUserOnly.toggle",
    path: "coupons/inputs/loggedInUserOnly.toggle",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/products/coupons/inputs/loggedInUserOnly.toggle.ts").then(m => m.default || m)
  },
  {
    name: "products-coupons-inputs-showCouponInfo.toggle",
    path: "coupons/inputs/showCouponInfo.toggle",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/products/coupons/inputs/showCouponInfo.toggle.ts").then(m => m.default || m)
  },
  {
    name: "products-coupons-inputs-showOnProductListing.toggle",
    path: "coupons/inputs/showOnProductListing.toggle",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/products/coupons/inputs/showOnProductListing.toggle.ts").then(m => m.default || m)
  },
  {
    name: "products-coupons-new",
    path: "coupons/new",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/products/coupons/new.vue").then(m => m.default || m)
  },
  {
    name: "products-customerGroupPrices",
    path: "customerGroupPrices",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/products/customerGroupPrices/index.vue").then(m => m.default || m)
  },
  {
    name: "products-debug",
    path: "debug",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/products/debug/index.vue").then(m => m.default || m)
  },
  {
    name: "products-hiddenProducts",
    path: "hiddenProducts",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/products/hiddenProducts/index.vue").then(m => m.default || m)
  },
  {
    name: "products",
    path: "",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/products/index.vue").then(m => m.default || m)
  },
  {
    name: "products-info-box-id",
    path: "info-box/:id()",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/products/info-box/[id].vue").then(m => m.default || m)
  },
  {
    name: "products-info-box",
    path: "info-box",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/products/info-box/index.vue").then(m => m.default || m)
  },
  {
    name: "products-info-box-new",
    path: "info-box/new",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/products/info-box/new.vue").then(m => m.default || m)
  },
  {
    name: "products-lowestPrices",
    path: "lowestPrices",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/products/lowestPrices/index.vue").then(m => m.default || m)
  },
  {
    name: materialSamplesNpKFNLEXEMMeta?.name,
    path: "materialSamples",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/products/materialSamples.vue").then(m => m.default || m),
    children: [
  {
    name: "products-materialSamples-id",
    path: ":id()",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/products/materialSamples/[id].vue").then(m => m.default || m)
  },
  {
    name: "products-materialSamples",
    path: "",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/products/materialSamples/index.vue").then(m => m.default || m)
  },
  {
    name: "products-materialSamples-new",
    path: "new",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/products/materialSamples/new.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "products-missingProducts",
    path: "missingProducts",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/products/missingProducts/index.vue").then(m => m.default || m)
  },
  {
    name: "products-new",
    path: "new",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/products/new.vue").then(m => m.default || m)
  },
  {
    name: "products-price-syncs-id",
    path: "price-syncs/:id()",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/products/price-syncs/[id].vue").then(m => m.default || m)
  },
  {
    name: "products-price-syncs",
    path: "price-syncs",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/products/price-syncs/index.vue").then(m => m.default || m)
  },
  {
    name: "products-price-syncs-new",
    path: "price-syncs/new",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/products/price-syncs/new.vue").then(m => m.default || m)
  },
  {
    name: promotionsCaGebW3onPMeta?.name,
    path: "promotions",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/products/promotions.vue").then(m => m.default || m),
    children: [
  {
    name: "products-promotions-id",
    path: ":id()",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/products/promotions/[id].vue").then(m => m.default || m)
  },
  {
    name: "products-promotions-bars-id",
    path: "bars/:id()",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/products/promotions/bars/[id].vue").then(m => m.default || m)
  },
  {
    name: "products-promotions-bars",
    path: "bars",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/products/promotions/bars/index.vue").then(m => m.default || m)
  },
  {
    name: "products-promotions-bars-new",
    path: "bars/new",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/products/promotions/bars/new.vue").then(m => m.default || m)
  },
  {
    name: "products-promotions-exact-promotions",
    path: "exact-promotions",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/products/promotions/exact-promotions/index.vue").then(m => m.default || m)
  },
  {
    name: "products-promotions",
    path: "",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/products/promotions/index.vue").then(m => m.default || m)
  },
  {
    name: "products-promotions-multibuy-promotions-id",
    path: "multibuy-promotions/:id()",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/products/promotions/multibuy-promotions/[id].vue").then(m => m.default || m)
  },
  {
    name: "products-promotions-multibuy-promotions",
    path: "multibuy-promotions",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/products/promotions/multibuy-promotions/index.vue").then(m => m.default || m)
  },
  {
    name: "products-promotions-multibuy-promotions-new",
    path: "multibuy-promotions/new",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/products/promotions/multibuy-promotions/new.vue").then(m => m.default || m)
  },
  {
    name: "products-promotions-new",
    path: "new",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/products/promotions/new.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "products-reviews-id",
    path: "reviews/:id()",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/products/reviews/[id].vue").then(m => m.default || m)
  },
  {
    name: "products-reviews",
    path: "reviews",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/products/reviews/index.vue").then(m => m.default || m)
  },
  {
    name: "products-reviews-inputs-rating.input",
    path: "reviews/inputs/rating.input",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/products/reviews/inputs/rating.input.ts").then(m => m.default || m)
  },
  {
    name: "products-reviews-new",
    path: "reviews/new",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/products/reviews/new.vue").then(m => m.default || m)
  },
  {
    name: "products-selection",
    path: "selection",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/products/selection.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "profile",
    path: "/profile",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/profile/index.vue").then(m => m.default || m)
  },
  {
    name: "purchase-webhooks",
    path: "/purchase-webhooks",
    meta: indexMGDQAFyzAjMeta || {},
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/purchase-webhooks/index.vue").then(m => m.default || m)
  },
  {
    name: "redirects-id",
    path: "/redirects/:id()",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/redirects/[id].vue").then(m => m.default || m)
  },
  {
    name: "redirects",
    path: "/redirects",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/redirects/index.vue").then(m => m.default || m)
  },
  {
    name: "redirects-new",
    path: "/redirects/new",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/redirects/new.vue").then(m => m.default || m)
  },
  {
    name: reportsJ9ulUSAu4cMeta?.name,
    path: "/reports",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/reports.vue").then(m => m.default || m),
    children: [
  {
    name: "reports",
    path: "",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/reports/index.vue").then(m => m.default || m)
  },
  {
    name: "reports-new-id",
    path: "new/:id()",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/reports/new/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: "reports-new",
    path: "new",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/reports/new/index.vue").then(m => m.default || m)
  },
  {
    name: "reports-product-metrics-id",
    path: "product-metrics/:id()",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/reports/product-metrics/[id].vue").then(m => m.default || m)
  }
]
  },
  {
    name: "roles-id",
    path: "/roles/:id()",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/roles/[id].vue").then(m => m.default || m)
  },
  {
    name: "roles",
    path: "/roles",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/roles/index.vue").then(m => m.default || m)
  },
  {
    name: "roles-new",
    path: "/roles/new",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/roles/new.vue").then(m => m.default || m)
  },
  {
    name: "sandbox",
    path: "/sandbox",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/sandbox.vue").then(m => m.default || m)
  },
  {
    name: "showrooms-id",
    path: "/showrooms/:id()",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/showrooms/[id].vue").then(m => m.default || m)
  },
  {
    name: "showrooms",
    path: "/showrooms",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/showrooms/index.vue").then(m => m.default || m)
  },
  {
    name: "showrooms-new",
    path: "/showrooms/new",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/showrooms/new.vue").then(m => m.default || m)
  },
  {
    name: "sitemaps-id",
    path: "/sitemaps/:id()",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/sitemaps/[id].vue").then(m => m.default || m)
  },
  {
    name: "sitemaps",
    path: "/sitemaps",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/sitemaps/index.vue").then(m => m.default || m)
  },
  {
    name: "sitemaps-new",
    path: "/sitemaps/new",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/sitemaps/new.vue").then(m => m.default || m)
  },
  {
    name: "speed4trade-detail",
    path: "/speed4trade/:id()",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/speed4trade/[id].vue").then(m => m.default || m)
  },
  {
    name: "speed4trade-history",
    path: "/speed4trade/history",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/speed4trade/history.vue").then(m => m.default || m)
  },
  {
    name: "speed4trade",
    path: "/speed4trade",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/speed4trade/index.vue").then(m => m.default || m)
  },
  {
    name: "static-site-urls-id",
    path: "/static-site-urls/:id()",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/static-site-urls/[id].vue").then(m => m.default || m)
  },
  {
    name: "static-site-urls",
    path: "/static-site-urls",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/static-site-urls/index.vue").then(m => m.default || m)
  },
  {
    name: "static-site-urls-new",
    path: "/static-site-urls/new",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/static-site-urls/new.vue").then(m => m.default || m)
  },
  {
    name: "statistics-customer",
    path: "/statistics/customer",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/statistics/customer.vue").then(m => m.default || m)
  },
  {
    name: "statistics-order",
    path: "/statistics/order",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/statistics/order.vue").then(m => m.default || m)
  },
  {
    name: stock_45poolsLnrvRR82hfMeta?.name,
    path: "/stock-pools",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/stock-pools.vue").then(m => m.default || m),
    children: [
  {
    name: "stock-pools-id",
    path: ":id()",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/stock-pools/[id].vue").then(m => m.default || m)
  },
  {
    name: "stock-pools",
    path: "",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/stock-pools/index.vue").then(m => m.default || m)
  },
  {
    name: "stock-pools-new",
    path: "new",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/stock-pools/new.vue").then(m => m.default || m)
  }
]
  },
  {
    name: stock_45source_45file_45downloadseJApJslVQrMeta?.name,
    path: "/stock-source-file-downloads",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/stock-source-file-downloads.vue").then(m => m.default || m),
    children: [
  {
    name: "stock-source-file-downloads-filters-status.select",
    path: "filters/status.select",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/stock-source-file-downloads/filters/status.select.ts").then(m => m.default || m)
  },
  {
    name: "stock-source-file-downloads-filters-stockPool.select",
    path: "filters/stockPool.select",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/stock-source-file-downloads/filters/stockPool.select.ts").then(m => m.default || m)
  },
  {
    name: "stock-source-file-downloads-filters-stockSourceFile.select",
    path: "filters/stockSourceFile.select",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/stock-source-file-downloads/filters/stockSourceFile.select.ts").then(m => m.default || m)
  },
  {
    name: "stock-source-file-downloads",
    path: "",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/stock-source-file-downloads/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: stock_45source_45filesmb4yfIVAfQMeta?.name,
    path: "/stock-source-files",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/stock-source-files.vue").then(m => m.default || m),
    children: [
  {
    name: "stock-source-files-id",
    path: ":id()",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/stock-source-files/[id].vue").then(m => m.default || m)
  },
  {
    name: "stock-source-files",
    path: "",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/stock-source-files/index.vue").then(m => m.default || m)
  },
  {
    name: "stock-source-files-new",
    path: "new",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/stock-source-files/new.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "tags-id",
    path: "/tags/:id()",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/tags/[id].vue").then(m => m.default || m)
  },
  {
    name: "tags",
    path: "/tags",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/tags/index.vue").then(m => m.default || m)
  },
  {
    name: "tags-new",
    path: "/tags/new",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/tags/new.vue").then(m => m.default || m)
  },
  {
    name: taxesgBzEAhdGkGMeta?.name,
    path: "/taxes",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/taxes.vue").then(m => m.default || m),
    children: [
  {
    name: "taxes-id",
    path: ":id()",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/taxes/[id].vue").then(m => m.default || m)
  },
  {
    name: "taxes",
    path: "",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/taxes/index.vue").then(m => m.default || m)
  },
  {
    name: "taxes-new",
    path: "new",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/taxes/new.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "teasers-id",
    path: "/teasers/:id()",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/teasers/[id].vue").then(m => m.default || m)
  },
  {
    name: "teasers-fallback.toggle",
    path: "/teasers/fallback.toggle",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/teasers/fallback.toggle.ts").then(m => m.default || m)
  },
  {
    name: "teasers",
    path: "/teasers",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/teasers/index.vue").then(m => m.default || m)
  },
  {
    name: "teasers-isActive.toggle",
    path: "/teasers/isActive.toggle",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/teasers/isActive.toggle.ts").then(m => m.default || m)
  },
  {
    name: "teasers-new",
    path: "/teasers/new",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/teasers/new.vue").then(m => m.default || m)
  },
  {
    name: templates91HnqPi0lSMeta?.name,
    path: "/templates",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/templates.vue").then(m => m.default || m),
    children: [
  {
    name: "templates-id",
    path: ":id()",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/templates/[id].vue").then(m => m.default || m)
  },
  {
    name: "templates",
    path: "",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/templates/index.vue").then(m => m.default || m)
  },
  {
    name: "templates-new",
    path: "new",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/templates/new.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "translations-bulk",
    path: "/translations/bulk",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/translations/bulk.vue").then(m => m.default || m)
  },
  {
    name: "translations-glossary",
    path: "/translations/glossary",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/translations/glossary.vue").then(m => m.default || m)
  },
  {
    name: "translations-inbox",
    path: "/translations/inbox",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/translations/inbox.vue").then(m => m.default || m)
  },
  {
    name: "translations",
    path: "/translations",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/translations/index.vue").then(m => m.default || m)
  },
  {
    name: "translations-inputs-moduleGroupSelect.input",
    path: "/translations/inputs/moduleGroupSelect.input",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/translations/inputs/moduleGroupSelect.input.ts").then(m => m.default || m)
  },
  {
    name: "translations-inputs-pageSelect.input",
    path: "/translations/inputs/pageSelect.input",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/translations/inputs/pageSelect.input.ts").then(m => m.default || m)
  },
  {
    name: "translations-inputs-productSelect.input",
    path: "/translations/inputs/productSelect.input",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/translations/inputs/productSelect.input.ts").then(m => m.default || m)
  },
  {
    name: "translations-inputs-translationModelSelect.input",
    path: "/translations/inputs/translationModelSelect.input",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/translations/inputs/translationModelSelect.input.ts").then(m => m.default || m)
  },
  {
    name: "translations-jobs-id",
    path: "/translations/jobs/:id()",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/translations/jobs/[id].vue").then(m => m.default || m)
  },
  {
    name: "translations-jobs",
    path: "/translations/jobs",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/translations/jobs/index.vue").then(m => m.default || m)
  },
  {
    name: "translations-playground",
    path: "/translations/playground",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/translations/playground.vue").then(m => m.default || m)
  },
  {
    name: "translations-review-id",
    path: "/translations/review/:id()",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/translations/review/[id].vue").then(m => m.default || m)
  },
  {
    name: "translations-settings",
    path: "/translations/settings",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/translations/settings.vue").then(m => m.default || m)
  },
  {
    name: "trendshows-id",
    path: "/trendshows/:id()",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/trendshows/[id].vue").then(m => m.default || m)
  },
  {
    name: "trendshows",
    path: "/trendshows",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/trendshows/index.vue").then(m => m.default || m)
  },
  {
    name: "trendshows-new",
    path: "/trendshows/new",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/trendshows/new.vue").then(m => m.default || m)
  },
  {
    name: user_45eventsnv197N6yShMeta?.name,
    path: "/user-events",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/user-events.vue").then(m => m.default || m),
    children: [
  {
    name: "user-events",
    path: "",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/user-events/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "users-id",
    path: "/users/:id()",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/users/[id].vue").then(m => m.default || m)
  },
  {
    name: "users",
    path: "/users",
    component: () => import("/home/nodejs/kare-backoffice-v2/source/pages/users/index.vue").then(m => m.default || m)
  }
]